const capitalize = word => word.substr(0, 1).toUpperCase() + word.substr(1)
const humanize = word => word.replace(/_/g, ' ')

export const getErrorFields = err => {
  const errorOrNoErrors = err?.response?.data?.error || !err?.response?.data?.errors

  if (errorOrNoErrors) {
    return []
  } else {
    return Object.keys(err?.response?.data?.errors)
  }
}

export const getErrorMessages = err => {
  const error = err?.response?.data?.error
  if (error) {
    return error
  }

  const errors = err?.response?.data?.errors
  if (!errors) {
    return ''
  }

  return getErrorArray(errors)
}

export const getErrorArray = errors => {
  if (typeof errors === 'string') {
    return [errors]
  }

  if (Array.isArray(errors)) {
    return errors
  }

  return Object.keys(errors).reduce((messages, key) => {
    const value = errors[key]
    messages.push(`${capitalize(humanize(key))} ${value}`)
    return messages
  }, [])
}

export const getErrorMessagesInSentence = err => {
  const messages = getErrorMessages(err)
  if (Array.isArray(messages)) {
    return messages.join('; ')
  }
  return messages
}

export const getErrorMessage = err => {
  const messages = getErrorMessages(err)
  if (Array.isArray(messages)) {
    return messages[0]
  }
  return messages
}

// Returns the first server error message verbatim, without prefixing the field
// name. Handles all shapes our API returns: a plain string, an array of full
// messages (e.g. `{ errors: ["..."] }`), or a field-keyed object (e.g. Devise's
// `{ errors: { base: ["..."] } }`). Use this when the backend already crafted a
// user-ready sentence and a "Base ..."/"Bio ..." prefix would read wrong.
export const getPlainErrorMessage = err => {
  const errors = err?.response?.data?.errors
  if (!errors) {
    return ''
  }

  if (typeof errors === 'string') {
    return errors
  }

  if (Array.isArray(errors)) {
    return errors[0] || ''
  }

  return Object.values(errors).flat()[0] || ''
}

export const getAxiosErrorMessage = err => {
  if (err.isAxiosError) {
    const responseData = err.response?.data || {}
    const errorKeys = ['error', 'message']

    for (const key of errorKeys) {
      if (responseData[key]) {
        return responseData[key]
      }
    }
  }

  return err?.message || 'Unknown error'
}
